import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Toggle from 'components/common/Toggle'
import { setEditorView, updateEmptyEntity } from 'actions/livefeed'
import update from 'immutability-helper';
import { isEqual } from 'lodash'
import ToolTip from 'react-portal-tooltip';

const EditorToggleButton = (props) => {
    const { currentEntity, fontFamily, editorView, dispatch } = props;

    const toggleEditorView = useCallback(() => {
        dispatch(setEditorView(update(editorView,
            { $set: !editorView }
        )))
        let emptyEntity = { id: null, fontFamily: fontFamily } // Prevent duplicate dispatch
        isEqual(emptyEntity, currentEntity) === false && (
            props.dispatch(updateEmptyEntity())// if there is chosen entity, dispatch empty
        )
    }, [currentEntity, dispatch, editorView, fontFamily, props])

    return (
        <React.Fragment>
            <div
                id="editor-guide"
                style={{ display: "flex" }}
                className={`justify-center`} onClick={() => toggleEditorView()}>
                <Toggle style={{ marginLeft: 10 }} isActive={editorView} />
            </div>
            <ToolTip active={true} parent={"#editor-guide"} position="right" arrow="center"
                style={{
                    style: {
                        background: "rgba(20, 20, 20, 0.9)",
                        padding: 10,
                        color: "#EEE",
                        boxShadow: "0px 4px 6px rgba(0,0,0,.3)",
                        fontSize: 12
                    },
                    arrowStyle: {
                        color: 'rgba(20, 20, 20, 0.9)',
                        borderColor: false
                    }
                }}
            >
                {editorView ? 'Click to disable Editor View' : 'Click to enable Editor View'}
                <br />Or right click on the floorplan to toggle view

            </ToolTip>

        </React.Fragment>
    );
}
EditorToggleButton.propTypes = {
    dispatch: PropTypes.func.isRequired,
    fontFamily: PropTypes.string.isRequired,
    editorView: PropTypes.bool.isRequired,
    currentEntity: PropTypes.object.isRequired
}
export default EditorToggleButton;



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/ToolbarContainer/ToolbarOptions/EditorToggleButton.jsx